<script>
  import Social from './Social'

  const { VUE_APP_API_HOST, VUE_APP_LINKEDIN_APPID, VUE_APP_LINKEDIN_CALLBACK } = process.env
  const scope = ['r_organization_social', 'w_member_social', 'w_organization_social', 'r_basicprofile', 'r_emailaddress', 'r_liteprofile', 'rw_organization_admin']

  export default {
    mixins: [Social],

    data() {
      return {
        pages: {
          facebook: [],
          twitter: [],
          linkedin: []
        },
      };
    },
    
    methods: {

      listInboxEvents(pages, from=null, filter=null, allPages=false) {
        let endpoint = `${VUE_APP_API_HOST}/inbox?${allPages ? 'allPages=true' : `pages=${pages.map(p => p.id).join(',')}`}`
        if(filter) {
          if(filter.userId) endpoint += `&userId=${filter.userId}`
          if(filter.type && filter.type.filter(t => t != '').length) endpoint += `&type=${filter.type.filter(t => t != '').join(',')}`
          if(filter.status) endpoint += `&status=${filter.status.join(',')}`
          if(filter.flag) endpoint += `&flag=${filter.flag}`
          if(filter.evaluation) endpoint += `&evaluation=${filter.evaluation.join(',')}`
          if(filter.affected_to) endpoint += `&affected_to=${filter.affected_to.map(u => u.id).join(',')}`
          if(filter.dateStart) endpoint += `&dateStart=${new Date(filter.dateStart).getTime()}`
          if(filter.dateEnd) endpoint += `&dateEnd=${new Date(filter.dateEnd).getTime()}`

          if(filter.asyncConversations) endpoint += `&asyncConversations=true`
        }
        if(from) endpoint += `&from=${from}`
        return this.$http
                   .get(endpoint, {
                     headers: {
                       Authorization: `Bearer ${localStorage.getItem('token')}`
                     }
                   })
                   .then(res => res, err => err)
      }, 
      
      getInboxUser(page, user) {
        const userId = user && (user.id || user.userId)
        return this.$http
                   .get(`${VUE_APP_API_HOST}/inbox/user?page=${page.id}&userId=${userId}`, {
                     headers: {
                       Authorization: `Bearer ${localStorage.getItem('token')}`
                     }
                   })
                   .then(res => res, err => err)
      },

      updateInboxUser(page, user, body) {
        const userId = user.id || user.userId
        return this.$http
                   .post(`${VUE_APP_API_HOST}/inbox/user?page=${page.id}&userId=${userId}`, body, {
                     headers: {
                       Authorization: `Bearer ${localStorage.getItem('token')}`
                     }
                   })
                   .then(res => res, err => err)
      }, 

      getInboxEvent(page, object_id){
         return this.$http
                   .get(`${VUE_APP_API_HOST}/inbox/event?page=${page}&object_id=${object_id}`, {
                     headers: {
                       Authorization: `Bearer ${localStorage.getItem('token')}`
                     }
                   })
                   .then(res => res, err => err)
        
      },

      postInboxEvent(id, page, body){
         return this.$http
                   .post(`${VUE_APP_API_HOST}/inbox/event?id=${id}&page=${page.id}`, body, {
                     headers: {
                       Authorization: `Bearer ${localStorage.getItem('token')}`
                     }
                   })
                   .then(res => res, err => err)
        
      },
      postInboxEvents(pages, body, all=false, ids=null){
        let filter = all ? {} : false
        if(all) {
          if(all.userId) filter.userId = all.userId
          if(all.type && all.type.filter(t => t != '').length) filter.type = all.type.filter(t => t != '').join(',')
          if(all.status) filter.status = all.status.join(',')
          if(all.flag) filter.flag = all.flag
          if(all.evaluation) filter.evaluation = all.evaluation.join(',')
          if(all.affected_to) filter.affected_to = all.affected_to.map(u => u.id).join(',')
          filter.from = 0
        }

         return this.$http
                   .post(`${VUE_APP_API_HOST}/inbox/events?pages=${pages.map(p => p.id).join(',')}`, {
                      ...body,
                      filter,
                      ids
                   }, {
                     headers: {
                       Authorization: `Bearer ${localStorage.getItem('token')}`
                     }
                   })
                   .then(res => res, err => err)
        
      },

      getDiscussionInbox(page, id){
        return this.$http
                   .get(`${VUE_APP_API_HOST}/inbox/conversation?page=${page && page.id}&id=${id}`, {
                     headers: {
                       Authorization: `Bearer ${localStorage.getItem('token')}`
                     }
                   })
                   .then(res => res, err => err)
      },

      getEventMissingInfosFromRS(page, id, type=null, moreData=null){
        if(moreData) moreData = new URLSearchParams(moreData)
        return this.$http
                   .get(`${VUE_APP_API_HOST}/inbox/event-missing-infos?page=${page}&id=${id}${moreData ? `&${moreData}` : ''}` + (type ? `&type=${type}` : ''), {
                     headers: {
                       Authorization: `Bearer ${localStorage.getItem('token')}`
                     }
                   })
                   .then(res => res, err => err)
      },

      countWaitingEvents(account, pages=null) {
        let param = pages ? `pages=${pages.map(p => p.id).join(',')}` : `account=${account}`
        return this.$http
                   .get(`${VUE_APP_API_HOST}/inbox/page/count?${param}`, {
                     headers: {
                       Authorization: `Bearer ${localStorage.getItem('token')}`
                     }
                   })
                   .then(res => res, err => err)
      },

      getPostFromRS(page, post, inbox=false) {
        return this.$http
                   .get(`${VUE_APP_API_HOST}/moderation/post?page=${page.id}&post=${post}${inbox ? `&inbox=true` : ''}`, {
                     headers: {
                       Authorization: `Bearer ${localStorage.getItem('token')}`
                     }
                   })
                   //.then(res => {return res.body.comments}, err => err)
                   .then(res => res, err => err)
      },

      getPostsFromRS(page) {
        return this.$http
                   .get(`${VUE_APP_API_HOST}/moderation/posts?page=${page.id}`, {
                     headers: {
                       Authorization: `Bearer ${localStorage.getItem('token')}`
                     }
                   })
                   .then(res => res, err => err)
      }, 

      getPreviousNextNodePageFromRS(link) {
        return this.$http
                   .get(link, {
                     headers: {
                       Authorization: `Bearer ${localStorage.getItem('token')}`
                     }
                   })
                   .then(res => res, err => err)
      },
      getPreviousNextNodePageFromRSLinkedin(page, link){
        return this.$http
                   .get(`${VUE_APP_API_HOST}/moderation/nextpost?page=${page.id}&link=${link}`, {
                     headers: {
                       Authorization: `Bearer ${localStorage.getItem('token')}`
                     }
                   })
                   //.then(res => {return res.body.comments}, err => err)
                   .then(res => res, err => err)
                   
      },
      
      getCommentsPost(page, post) {
        return this.$http
                   .get(`${VUE_APP_API_HOST}/moderation/comments?page=${page.id}&post=${post}`, {
                     headers: {
                       Authorization: `Bearer ${localStorage.getItem('token')}`
                     }
                   })
                   //.then(res => {return res.body.comments}, err => err)
                   .then(res => res, err => err)
                   
      },

      getCommentPost(page, post, comment) {
        return this.$http
                   .get(`${VUE_APP_API_HOST}/moderation/comment?page=${page.id}&post=${post}&comment=${comment}`, {
                     headers: {
                       Authorization: `Bearer ${localStorage.getItem('token')}`
                     }
                   })
                   //.then(res => {return res.body.comments}, err => err)
                   .then(res => res, err => err)
                   
      },

      blockUserComment(page, userId, secUid = null, uniqueId = null){
         return this.$http
                   .post(`${VUE_APP_API_HOST}/moderation/comments/block?page=${page.id}&userId=${userId}&secUid=${secUid}&uniqueId=${uniqueId}`, {
                     headers: {
                       Authorization: `Bearer ${localStorage.getItem('token')}`
                     }
                   })
                   .then(res => res, err => err)
        
      },

       deleteNodelinkedin(page, postactivity, nodeId) {
        return this.$http
                   .delete(`${VUE_APP_API_HOST}/moderation/comments?page=${page.id}&nodeId=${nodeId}&postactivity=${postactivity}`, {
                     headers: {
                       Authorization: `Bearer ${localStorage.getItem('token')}`
                     }
                   })
                   .then(res => res, err => err)
      },

      deleteNode(page, nodeId) {
        return this.$http
                   .delete(`${VUE_APP_API_HOST}/moderation/comments?page=${page.id}&nodeId=${nodeId}`, {
                     headers: {
                       Authorization: `Bearer ${localStorage.getItem('token')}`
                     }
                   })
                   .then(res => res, err => err)
      },
      
      hideNode(page, nodeId, is_hidden){
        return this.$http
                   .post(`${VUE_APP_API_HOST}/moderation/comments/hide?page=${page.id}&nodeId=${nodeId}`,{ is_hidden },{
                     headers: {
                       Authorization: `Bearer ${localStorage.getItem('token')}`
                     }
                   })
                   .then(res => res, err => err)
      },

      getConversations(page){
        console.log('arrivé dans getConversations mixin',page.id)
        return this.$http
                 .get(`${VUE_APP_API_HOST}/moderation/conversations?page=${page.id}`, {
                     headers: {
                       Authorization: `Bearer ${localStorage.getItem('token')}`
                     }
                   })
                   .then(res => res, err => err)
      }, 

       getDoneConversations(page){
        console.log('arrivé dans getDoneConversations mixin',page.id)
        return this.$http
                 .get(`${VUE_APP_API_HOST}/moderation/conversationsdone?page=${page.id}`, {
                     headers: {
                       Authorization: `Bearer ${localStorage.getItem('token')}`
                     }
                   })
                   .then(res => res, err => err)
      },

      getConversationsByName(page){
        console.log('arrivé dans getConversationsByName mixin',page.id)
        return this.$http
                 .get(`${VUE_APP_API_HOST}/moderation/conversationsbyname?page=${page.id}`, {
                     headers: {
                       Authorization: `Bearer ${localStorage.getItem('token')}`
                     }
                   })
                   .then(res => res, err => err)
      },
        getSpamConversations(page){
        console.log('arrivé dans getSpamConversations mixin',page.id)
        return this.$http
                 .get(`${VUE_APP_API_HOST}/moderation/conversationsspam?page=${page.id}`, {
                     headers: {
                       Authorization: `Bearer ${localStorage.getItem('token')}`
                     }
                   })
                   .then(res => res, err => err)
      }, 

        getFollowConversations(page){
        console.log('arrivé dans getFollowConversations mixin',page.id)
        return this.$http
                 .get(`${VUE_APP_API_HOST}/moderation/conversationsfollow?page=${page.id}`, {
                     headers: {
                       Authorization: `Bearer ${localStorage.getItem('token')}`
                     }
                   })
                   .then(res => res, err => err)
      }, 

      getDiscussion(page, conversationid){
        console.log('arrivé dans getDisussion mixin',page.id,conversationid)
        return this.$http
                 .get(`${VUE_APP_API_HOST}/moderation/discussion?page=${page.id}&conversation=${conversationid}`, {
                     headers: {
                       Authorization: `Bearer ${localStorage.getItem('token')}`
                     }
                   })
                   .then(res => res, err => err)
      }, 

      getUser(page, id){
        console.log('arrivé dans getUser mixin',id)
        return this.$http
                 .get(`${VUE_APP_API_HOST}/moderation/user?page=${page.id}&id=${id}`, {
                     headers: {
                       Authorization: `Bearer ${localStorage.getItem('token')}`
                     }
                   })
                   .then(res => res, err => err)
      }, 

      getAttachment(page, messageid){
         console.log('arrivé dans getAttachment mixin')
        return this.$http
                 .get(`${VUE_APP_API_HOST}/moderation/attachment?page=${page.id}&messageid=${messageid}`, {
                     headers: {
                       Authorization: `Bearer ${localStorage.getItem('token')}`
                     }
                   })
                   .then(res => res, err => err)
      }, 


     addComment(page, nodeId, message, mediaId=null) {
        return this.$http
                   .post(`${VUE_APP_API_HOST}/moderation/comments?page=${page.id}&nodeId=${nodeId}` + (mediaId ? `&mediaId=${mediaId}` : ''), { message }, {
                     headers: {
                       Authorization: `Bearer ${localStorage.getItem('token')}`
                     }
                   })
                   .then(res => res, err => err)
      },
      sendPrivateReply(page, commentId, message) {
        return this.$http
                   .post(`${VUE_APP_API_HOST}/moderation/comment/private-reply?page=${page.id}&commentId=${commentId}`, { message }, {
                     headers: {
                       Authorization: `Bearer ${localStorage.getItem('token')}`
                     }
                   })
                   .then(res => res, err => err)
      },
      reactMessage(page, recipientid, discussionid, react) {
        console.log('Reactmessage moderation mixin')
        return this.$http
                   .post(`${VUE_APP_API_HOST}/moderation/messagereact?page=${page.id}&recipientid=${recipientid}&react=${react}&message=${discussionid}`, {
                     headers: {
                       Authorization: `Bearer ${localStorage.getItem('token')}`
                     }
                   })
                   .then(res => res, err => err)
      },
      addCommentPost(page, nodeId, message) {
        return this.$http
                   .post(`${VUE_APP_API_HOST}/moderation/commentspost?page=${page.id}&nodeId=${nodeId}`, { message }, {
                     headers: {
                       Authorization: `Bearer ${localStorage.getItem('token')}`
                     }
                   })
                   .then(res => res, err => err)
      },
      switchComments(page, postid, postiscommentenable){
        console.log('entré dans switchcomments mixin ', postid, postiscommentenable)
        return this.$http
                   .post(`${VUE_APP_API_HOST}/moderation/commentspostenable?page=${page.id}&postid=${postid}&postcommentenable=${postiscommentenable}`, {
                     headers: {
                       Authorization: `Bearer ${localStorage.getItem('token')}`
                     }
                   })
                   .then(res => res, err => err)
      },

      sendMessage(page, recipientId, formdata ) {
        console.log('entré dans la mixin sendmessage')
        console.log(recipientId)
        console.log('image dans la mixin :')
         for (var value of formdata.values()) {
      console.log("formdata", value);
      }      
        return this.$http
                   .post(`${VUE_APP_API_HOST}/moderation/message?page=${page.id}&recipientId=${recipientId}`, formdata, {
                     headers: {
                       Authorization: `Bearer ${localStorage.getItem('token')}`
                     }
                   })
                   .then(res => res, err => err)
      },
      postRead(page, recipientId) {
       // console.log('entré dans la mixin postread')
       // console.log(recipientId)
        return this.$http
                   .post(`${VUE_APP_API_HOST}/moderation/messagereaded?page=${page.id}&recipientId=${recipientId}`, {
                     headers: {
                       Authorization: `Bearer ${localStorage.getItem('token')}`
                     }
                   })
                   .then(res => res, err => err)
      },

      likeNode(page, nodeId, postactivity=null, unlike=false, type=null) {
        return this.$http
                   .post(`${VUE_APP_API_HOST}/moderation/likes?page=${page.id}&nodeId=${nodeId}&postactivity=${postactivity}&unlike=${unlike}${type ? `&type=${type}` : ''}`, {
                     headers: {
                       Authorization: `Bearer ${localStorage.getItem('token')}`
                     }
                   })
                   .then(res => res, err => err)
      },

      listReviews(page){
        return this.$http
                 .get(`${VUE_APP_API_HOST}/moderation/reviews?page=${page.id}`, {
                     headers: {
                       Authorization: `Bearer ${localStorage.getItem('token')}`
                     }
                   })
                   .then(res => res, err => err)
      }, 

      replyToReview(page, review, content){
        return this.$http
                 .post(`${VUE_APP_API_HOST}/moderation/reviews?page=${page.id}&reviewId=${review.reviewId}&content=${content}`, {
                     headers: {
                       Authorization: `Bearer ${localStorage.getItem('token')}`
                     }
                   })
                   .then(res => res, err => err)
      }, 

      removeReplyToReview(page, review){
        return this.$http
                 .delete(`${VUE_APP_API_HOST}/moderation/reviews?page=${page.id}&reviewId=${review.reviewId}`, {
                     headers: {
                       Authorization: `Bearer ${localStorage.getItem('token')}`
                     }
                   })
                   .then(res => res, err => err)
      },
    }
  }
</script>
